import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toggleHeaderMenuExpanded } from '../../settings/actions/application-actions';

class CartHeader extends Component {
	render() {
		const { toggleHeaderMenuExpanded } = this.props;
		const title = this.props.title ? (
            <div className="header-flex-left">
                <h1 style={{textTransform: "none"}}>{this.props.title}</h1>
            </div>
		) : ""
		return (
			<header className="header-flex-container header-default header-cart no-print">
				<div className="header-flex-left">
					<div className="hamburger-menu-container" onClick={toggleHeaderMenuExpanded}>
						<div className="hamburger-menu" />
						<span>Menu</span>
					</div>
					<div className="header-item logo" onClick={this.props.navigateHome}>
						&nbsp;
						<span className="hidden">iMemories&reg;</span>
					</div>
                    { title }
					{/*<img className="trusted" src={require("../../cart/images/cart-trusted-icons.png")} alt="Trusted Site"/>*/}

                    {/*<a href="#" className="trusted-1" alt="Trusted Site"></a>*/}
                    {/*<a href="#" className="trusted-2" alt="Trusted Site"></a>*/}
                    {/*<a href="#" className="trusted-3" alt="Trusted Site"></a>*/}
				</div>

				{/*<div className="header-flex-right">*/}
					{/*<div className="header-flex-spacer" />*/}
                    {/*<div className="header-item header-item-right">*/}
                        {/*<img src={require("../../cart/images/cart-trusted-icons.png")} alt="Trusted Site"/>*/}
                    {/*</div>*/}
				{/*</div>*/}
			</header>
		);
	}
}

CartHeader.propTypes = {
	toggleHeaderMenuExpanded: PropTypes.func,
	navigateHome: PropTypes.func
};

const mapDispatchToProps = dispatch => {
	return {
		toggleHeaderMenuExpanded: (evt) => {
			dispatch(toggleHeaderMenuExpanded());
			if(evt) evt.stopPropagation();
		}
	};
};

export default connect(null, mapDispatchToProps)(CartHeader);



// WEBPACK FOOTER //
// ./src/header/components/cart-header.jsx